import React,{useState,useEffect} from 'react';
import {catalogSettings,saveCatalogSettings} from '../api/catalogSearchApi';
import s from './CatalogSearchPage.module.css';
export default function CatalogLlmSettings(){
 const [settings,setSettings]=useState(null),[error,setError]=useState(''),[busy,setBusy]=useState(false),[saved,setSaved]=useState('');
 useEffect(()=>{let alive=true;catalogSettings().then(v=>{if(alive)setSettings(v)}).catch(e=>{if(alive)setError(e.message)});return()=>{alive=false}},[]);
 async function save(){setBusy(true);setError('');setSaved('');try{const r=await saveCatalogSettings({search_engine:settings.search_engine||'v3',interpret_provider:settings.interpret_provider,interpret_ollama_model:settings.interpret_ollama_model,...((settings.search_engine||'v3')==='v3'?{retrieval_method:settings.retrieval_method||'hybrid'}:{})});setSettings(current=>({...current,...r,available_models:r.available_models||current.available_models}));setSaved('Сохранено.')}catch(e){setError(e.message)}finally{setBusy(false)}}
 if(!settings)return <section className={s.panel}><h2 className={s.title}>Ядро поиска номенклатуры</h2><p className={s.muted}>Загрузка…</p></section>;
 const models=(settings.available_models||[]).filter(m=>m.kind==='ollama');
 const provider=settings.interpret_provider||'auto';
 return <section className={s.panel}>
  <h2 className={s.title}>Ядро поиска номенклатуры</h2>
  <p>Выберите, как разбирать текст запроса. Без LLM доступны точные правила и явный выбор категории и характеристик.</p>
  <div className={s.toolbar}>
   <label>Способ поиска
    <select className={s.input} aria-label="Способ поиска" value={settings.search_engine||'v3'} onChange={e=>setSettings({...settings,search_engine:e.target.value})}>
     <option value="v1">Поиск v1</option><option value="v2">Поиск v2</option><option value="v3">Поиск v3 — характеристики и назначение</option>
    </select>
   </label>
   {(settings.search_engine||'v3')==='v3'&&<label>Метод поиска v3
    <select className={s.input} aria-label="Метод поиска v3" value={settings.retrieval_method||'hybrid'} onChange={e=>setSettings({...settings,retrieval_method:e.target.value})}>
     <option value="hybrid">Поиск v3</option><option value="hybrid_ngram">Поиск v3 + n-gram</option>
    </select>
   </label>}
   <label>Модель разбора параметров
    <select className={s.input} aria-label="Модель разбора параметров" value={provider} onChange={e=>setSettings({...settings,interpret_provider:e.target.value})}>
     <option value="none">Без LLM — правила и фильтры</option>
     <option value="auto">DeepSeek + резерв Ollama (авто)</option>
     <option value="deepseek">DeepSeek</option>
     <option value="ollama">Ollama (локальная)</option>
    </select>
   </label>
   {provider==='ollama'&&<label>Модель Ollama
    <select className={s.input} aria-label="Модель Ollama" value={settings.interpret_ollama_model||''} onChange={e=>setSettings({...settings,interpret_ollama_model:e.target.value})}>
     {models.length?models.map(m=><option key={m.id} value={m.id}>{m.label}</option>):<option value="">— нет моделей —</option>}
    </select>
   </label>}
   <button className={s.button} disabled={busy} onClick={save}>{busy?'Сохранение…':'Сохранить'}</button>
  </div>
  {saved&&<p className={s.muted}>{saved}</p>}
  {error&&<p role="alert" className={s.error}>{error}</p>}
  <p className={s.muted}>{provider==='none'?'Неоднозначный текст попросит уточнение; выбранные фильтры выполняются параметризованным SQL.':'Векторизация справочника выполняется локально. В DeepSeek передаются запрос и найденные термины справочника.'}</p>
 </section>;
}
